import { lazy } from 'react';

const RELOAD_KEY = 'chunk-reload-attempted';

// React.lazy wrapper: after a deploy, chunk hashes change and an open tab may request
// a chunk that no longer exists. Reload once to pick up the new index.html.
const lazyWithRetry = (importer) =>
  lazy(() =>
    importer()
      .then((module) => {
        try { sessionStorage.removeItem(RELOAD_KEY); } catch (e) {}
        return module;
      })
      .catch((error) => {
        let attempted = false;
        try { attempted = sessionStorage.getItem(RELOAD_KEY) === '1'; } catch (e) {}
        if (!attempted) {
          try { sessionStorage.setItem(RELOAD_KEY, '1'); } catch (e) {}
          window.location.reload();
          return new Promise(() => {});
        }
        throw error;
      })
  );

export default lazyWithRetry;
